import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LinkContainer } from 'react-router-bootstrap';
import moment from 'moment';
import { actionCreators } from '../../store/modules/User';
import SelectField from '../../controls/SelectField';
import { YesNo, ConvertToOptions, Gender } from '../../utils/enum';
import SaveButton from '../../controls/SaveButton';
import confirm from '../../utils/confirm';
import BackButton from '../../controls/BackButton';

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
    };
    this.form = React.createRef();
  }

  componentWillMount() {
    const { requestGet } = this.props;
    const { id } = this.state;

    requestGet(id);
  }

  handleSave(values) {
    const { requestPut } = this.props;
    const { id } = this.state;

    requestPut(id, values);
  }

  handleDelete() {
    const { requestDelete } = this.props;
    const { id } = this.state;

    confirm().then(() => requestDelete(id));
  }

  testDate() {
    const date = moment([this.parent.birthdayOnYear, this.parent.birthdayOnMonth - 1, this.parent.birthdayOnDay]);
    return date.isValid();
  }

  render() {
    const { user } = this.props;
    const { id } = this.state;

    return (
      <Formik onSubmit={values => this.handleSave(values)}
        ref={this.form}
        enableReinitialize
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .email()
            .min(5)
            .max(254)
            .required(),
          phone: Yup.string()
            .min(12)
            .max(12)
            .required(),
          birthdayOnDay: Yup.number()
            .integer()
            .required()
            .test('valid-date', 'Nepareizs datums', this.testDate),
          birthdayOnMonth: Yup.number()
            .integer()
            .required()
            .test('valid-date', 'Nepareizs datums', this.testDate),
          birthdayOnYear: Yup.number()
            .integer()
            .required()
            .test('valid-date', 'Nepareizs datums', this.testDate),
          isMale: Yup.bool().nullable(),
          isSubscribed: Yup.bool().required(),
        })}
        initialValues={
          user || {
            email: '',
            phone: '',
            cardNo: '',
            birthdayOnDay: '',
            birthdayOnMonth: '',
            birthdayOnYear: '',
            isSubscribed: '',
            isMale: '',
          }
        }
        render={({ errors }) => (
          <Form>
            <div id="dataForm">
              <div className="row m-b-sm">
                <div className="col-sm-12">
                  <span className="page-title m-l-lg">Profils</span>
                  <div className="pageStyle">
                    {id && <BackButton />}
                    {id ? (
                      <button type="button" className="delete-btn"
                        onClick={() => this.handleDelete()}>
                        <i className="glyphicon glyphicon-floppy-remove" />
                        <div className="hover-text">Dzēst Profilu</div>
                      </button>
                    ) : (
                      <LinkContainer to="user/delete">
                        <button type="button" className="delete-btn">
                          <i className="glyphicon glyphicon-floppy-remove" />
                          <div className="hover-text">Dzēst Profilu</div>
                        </button>
                      </LinkContainer>
                    )}
                    {!id && (
                      <LinkContainer to="user/password">
                        <button type="button" className="password-btn">
                          <i className="glyphicon glyphicon-lock" />
                          <div className="hover-text">Paroles Maiņa</div>
                        </button>
                      </LinkContainer>
                    )}
                    <SaveButton />
                  </div>
                </div>
              </div>
              <div className="row p-l-md">
                <div className="col-md-12">
                  <div className="panel panel-default">
                    <div className="panel-heading" />
                    <div className="panel-body" id="scroller">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="cardNo" className="control-label font-bold">
                                Kartes Nr
                                <Field id="cardNo"
                                  name="cardNo"
                                  readOnly
                                  className={errors.cardNo ? 'form-control error readOnly' : 'form-control readOnly'} />
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="birthdayOn" className="control-label font-bold">
                                Dzimšanas diena (diena/mēnesis/gads)
                                <div className="form-inline birthday-fields">
                                  <Field id="birthdayOnDay"
                                    name="birthdayOnDay"
                                    readOnly
                                    style={{ width: '33%' }}
                                    className={errors.birthdayOnDay ? 'form-control error readOnly' : 'form-control readOnly'} />
                                  <Field id="birthdayOnMonth"
                                    name="birthdayOnMonth"
                                    readOnly
                                    style={{ width: '33%' }}
                                    className={errors.birthdayOnMonth ? 'form-control error readOnly' : 'form-control readOnly'} />
                                  <Field id="birthdayOnYear"
                                    name="birthdayOnYear"
                                    readOnly
                                    style={{ width: '33%' }}
                                    className={errors.birthdayOnYear ? 'form-control error readOnly' : 'form-control readOnly'} />
                                </div>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="email" className="control-label font-bold">
                                Epasts
                                <Field id="email"
                                  name="email"
                                  type="email"
                                  readOnly
                                  className={errors.email ? 'form-control error readOnly' : 'form-control readOnly'} />
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="phone" className="control-label font-bold">
                                Tālrunis
                                <Field id="phone"
                                  name="phone"
                                  readOnly
                                  className={errors.phone ? 'form-control error readOnly' : 'form-control readOnly'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="isMale" className="control-label font-bold">
                                Dzimums
                                <Field id="isMale"
                                  name="isMale"
                                  component={SelectField}
                                  options={ConvertToOptions(Gender)}
                                  className={errors.isMale ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="isSubscribed" className="control-label font-bold">
                                Pierakstījies jaunumiem
                                <Field id="isSubscribed"
                                  name="isSubscribed"
                                  component={SelectField}
                                  options={ConvertToOptions(YesNo)}
                                  className={errors.isSubscribed ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )} />
    );
  }
}

UserProfile.propTypes = {
  user: PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }),
  requestGet: PropTypes.func.isRequired,
  requestPut: PropTypes.func.isRequired,
  requestDelete: PropTypes.func.isRequired,
  match: PropTypes.shape().isRequired,
};

UserProfile.defaultProps = {
  user: null,
};

export default connect(
  state => ({
    user: state.user.current,
  }),
  dispatch => bindActionCreators(actionCreators, dispatch),
)(UserProfile);



// WEBPACK FOOTER //
// ./src/components/user/Profile.jsx